import { render, staticRenderFns } from "./DashboardFilterChips.vue?vue&type=template&id=29795f26&"
import script from "./DashboardFilterChips.vue?vue&type=script&lang=js&"
export * from "./DashboardFilterChips.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports